// extracted by mini-css-extract-plugin
var _1 = "Popover-module__floating--e3Il4";
var _2 = "Popover-module__isClosed--Y9Zyu";
export { _1 as "floating", _2 as "isClosed" }
